module.exports = __webpack_public_path__ + "img/6.c8f5cd7e.png";